import { apiFetch } from "./apiClient";

export function listarMetas() {
    return apiFetch("/api/metas");
}

export function crearMeta(payload) {
    return apiFetch("/api/metas", {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function actualizarMeta(id, payload) {
    return apiFetch(`/api/metas/${id}`, {
        method: "PUT",
        body: JSON.stringify(payload),
    });
}

export function registrarAporteMeta(idMeta, payload) {
    return apiFetch(`/api/metas/${idMeta}/aportes`, {
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function listarAportesMeta(idMeta) {
    return apiFetch(`/api/metas/${idMeta}/aportes`);
}